import type { ReactNode } from 'react'
import { Seo } from '@saas-pages/shared/public/seo'
import { seoFor, type RouteKey } from '@/seo/routes'
import { useLocale } from '@/shared/i18n'

interface DateifyRouteSeoProps {
  routeKey: RouteKey
  children: ReactNode
}

export function DateifyRouteSeo({ routeKey, children }: DateifyRouteSeoProps) {
  const { locale } = useLocale()
  const seo = seoFor(routeKey, locale)

  return (
    <>
      <Seo metadata={seo.metadata} />
      {children}
    </>
  )
}
